import React, { useState, ReactNode } from 'react';
import { ModalContext } from './modalContext';

export const ModalProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [modalContent, setModalContent] = useState<ReactNode | null>(null);
  const [modalSize, setModalSize] = useState<'small' | 'default' | 'large'>('default');
  const [customClasses, setCustomClasses] = useState<string | undefined>(undefined);

  const openModal = (
    content: ReactNode,
    sizeOrClasses: 'small' | 'default' | 'large' | string = 'default'
  ) => {
    const isPresetSize = ['small', 'default', 'large'].includes(sizeOrClasses);
    setModalSize(isPresetSize ? sizeOrClasses as 'small' | 'default' | 'large' : 'default');
    setCustomClasses(!isPresetSize ? sizeOrClasses : undefined);
    setModalContent(content);
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
    setModalContent(null);
  };

  return (
    <ModalContext.Provider value={{ isOpen, modalContent, modalSize, customClasses, openModal, closeModal }}>
      {children}
    </ModalContext.Provider>
  );
};
